/**
 * Get Application Languages Use Case
 * Orchestrates fetching available languages for the kiosk
 */

import { LanguagesRepository } from '../data/languages-repository';
import { LanguageItem } from '../types/languages-types';

export class GetApplicationLanguagesUseCase {
  constructor(private repository: LanguagesRepository) {}

  async execute(): Promise<LanguageItem[]> {
    return this.repository.getAvailableLanguages();
  }
}
